/**
 * Who can see a saved artifact. Artifacts never cross shows, so these values
 * describe visibility within one show. One list, used by the Mongo enum
 * (`models/Artifact.js`), the api's validation and the frontend's toggle.
 */
export const ArtifactVisibility = {
    /** Only the user who owns it */
    Private: 'private',
    /** Anyone on the show */
    Public: 'public',
} as const

export type ArtifactVisibility = (typeof ArtifactVisibility)[keyof typeof ArtifactVisibility]

export const ARTIFACT_VISIBILITIES: ArtifactVisibility[] = Object.values(ArtifactVisibility)

export const DEFAULT_ARTIFACT_VISIBILITY: ArtifactVisibility = ArtifactVisibility.Private

export const isArtifactVisibility = (value: unknown): value is ArtifactVisibility =>
    typeof value === 'string' && (ARTIFACT_VISIBILITIES as string[]).includes(value)
